import { useEffect, useState } from "react";
import { SVG } from "ui";
import { GiphyFetch } from "@giphy/js-fetch-api";
import { IGif } from "@giphy/js-types";
import { GeneralModalProps } from "utils/types/generalTypes";

export type ChatGiFsModalProps = GeneralModalProps & {
    selectGif: Function;
};

const ChatGiFsModal = ({ open, setOpen, selectGif }: ChatGiFsModalProps) => {
    const API_KEY = "ETxtLJbeIUXaXdD9UM25l6useBNqJuP6";
    const limit = 15;
    const rating = "g";

    const [searchVal, setSearchVal] = useState("");
    const [fetchType, setFetchType] = useState<"trending" | "search">(
        "trending"
    );
    const [searchOffest, setSearchOffest] = useState(0);
    const [trendingOffest, setTrendingOffest] = useState(0);

    const [trendingGifs, setTrendingGifs] = useState<IGif[]>([]);
    const [searchGifs, setSearchGifs] = useState<IGif[]>([]);

    const handleChangeSearchVal = (val: string) => {
        setSearchVal(val);
        if (val.length >= 1) {
            setFetchType("search");
            setSearchOffest(0);
            fetchSearch();
        } else {
            setFetchType("trending");
        }
    };

    // fetch data
    // const fetchGifs
    const gf = new GiphyFetch(API_KEY);

    const fetchTrending = async () => {
        try {
            const { data: gifs } = await gf.trending({
                limit,
                offset: trendingOffest,
                rating
            });
            setTrendingOffest(() => trendingOffest + 1);
            setTrendingGifs([...trendingGifs, ...gifs]);
        } catch (err) {
            console.log("err form giphy", err);
        }
    };
    const fetchSearch = async () => {
        try {
            const { data: gifs } = await gf.search(searchVal, {
                limit,
                offset: searchOffest,
                rating
            });
            setSearchOffest(() => searchOffest + 1);
            setSearchGifs([...searchGifs, ...gifs]);
        } catch (err) {
            console.log("err form giphy", err);
        }
    };

    const loadMoreGifs = () => {
        if (fetchType == "search") {
            fetchSearch();
        } else {
            fetchTrending();
        }
    };

    useEffect(() => {
        fetchTrending();
    }, []);

    // edit here ------------------------------
    const addGif2Post = (url: string) => {
        selectGif(url);
        setOpen(false);
    };

    const handleCloseForm = () => {
        setOpen(false);
    };
    // end edit here ------------------------------

    return (
        <div
            id="gifs-modal"
            className={`modal is-small has-light-bg ${open ? "is-active" : ""}`}
            style={{ zIndex: 9999 }}
        >
            <div className="modal-background"></div>
            <div className="modal-content">
                <div className="card is-new-content">
                    <div className="card-heading flex-a-start">
                        <p className="momeento-p">GIFs</p>
                        {/* <!-- Close X button --> */}
                        <div className="close-wrap">
                            <span
                                className="custom-close-modal"
                                onClick={() => handleCloseForm()}
                            >
                                <SVG svg="x" size={16} />
                            </span>
                        </div>
                    </div>

                    <div className="card-body">
                        <div className="control">
                            <div className="field">
                                {/* <!-- <label>Icon Input</label> --> */}
                                <div className="control has-icon">
                                    <input
                                        type="text"
                                        className="input is-rounded"
                                        onChange={(e) =>
                                            handleChangeSearchVal(
                                                e.target.value
                                            )
                                        }
                                    />
                                    <div className="form-icon">
                                        <i data-feather="search"></i>
                                    </div>
                                </div>
                            </div>

                            <div className="hold-gifs-scroll">
                                {fetchType == "trending" ? (
                                    <div
                                        className={`gifs-container trending-gifs-container d-flex flex-wrap flex-a-end flex-j-between gap-5`}
                                    >
                                        {trendingGifs.map((gif) => (
                                            <img
                                                key={gif.id}
                                                src={
                                                    gif.images
                                                        .fixed_height_small.url
                                                }
                                                alt={gif.alt_text}
                                                onClick={() =>
                                                    addGif2Post(
                                                        gif.images.original.url
                                                    )
                                                }
                                            ></img>
                                        ))}
                                    </div>
                                ) : (
                                    ""
                                )}

                                {fetchType == "search" ? (
                                    <div
                                        className={`gifs-container search-gifs-container d-flex flex-wrap flex-a-end flex-j-between gap-5`}
                                    >
                                        {searchGifs.map((gif) => (
                                            <img
                                                key={gif.id}
                                                src={
                                                    gif.images
                                                        .fixed_height_small.url
                                                }
                                                alt={gif.alt_text}
                                                onClick={() =>
                                                    addGif2Post(
                                                        gif.images.original.url
                                                    )
                                                }
                                            ></img>
                                        ))}
                                    </div>
                                ) : (
                                    ""
                                )}
                                <div className="load-more-div d-flex flex-j-center flex-a-center mt-20 mb-20">
                                    <button
                                        className="button is-primary primary-btn raised"
                                        onClick={loadMoreGifs}
                                    >
                                        Load More
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatGiFsModal;
